import "./App.css";
import { Routes, Route } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Home from "./components/Pages/Home/Home.jsx";
import Treasury from "./components/Pages/Treasury/Treasury";
import Token from "./components/Pages/Token/Token";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import PolygonCondoTreasury from "./components/Pages/WalletTreasury/PolygonCondoTreasury";
import CondoEthereumTreasury from "./components/Pages/WalletTreasury/CondoEthereumTreasury";
import Treasury3 from "./components/Pages/WalletTreasury/Treasury3";
import TreasuryBase from "./components/Pages/WalletTreasury/TreasuryBase";
import CondoBaseTreasury from "./components/Pages/WalletTreasury/CondoBaseTreasury";
import Landing from "./components/Pages/Landing/Landing.jsx";
import Layout from "./components/Layout/Layout.jsx";
import TreasureOverview from "./components/Pages/TreasuryOverview/TreasuryOverview.jsx";
import TreasuryContextProvider from "./context/TreasuryContextProvider.jsx";
import BNBCondoTreasury from "./components/Pages/WalletTreasury/BNBCondoTreasury.jsx";
import MapleCondoTreasury from "./components/Pages/WalletTreasury/MapleCondoTreasury.jsx";
import IndexCoopTreasury from "./components/Pages/WalletTreasury/IndexCoopTreasury.jsx";
import DevWallet from "./components/Pages/WalletTreasury/DevWallet.jsx";

function App() {
  return (
    <div className="aclonica-regular">
      <TreasuryContextProvider>
        <Router>
          <div className="body-main">
            <Routes>
              {/* <Route path="/" element={<Landing />} /> */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Layout />}>
                <Route path="/home" element={<Home />} />
                <Route
                  path="/home/treasury-overview"
                  element={<TreasureOverview />}
                />
                <Route path="/home/treasury" element={<Treasury />} />
                <Route path="/home/token" element={<Token />} />
                <Route
                  path="/home/polygoncondotreasury"
                  element={<PolygonCondoTreasury />}
                />
                <Route
                  path="/home/condoethereumtreasury"
                  element={<CondoEthereumTreasury />}
                />{" "}
                <Route path="/home/tresury3treasury" element={<Treasury3 />} />{" "}
                <Route
                  path="/home/condobasetreasury"
                  element={<CondoBaseTreasury />}
                />
                <Route
                  path="/home/tresurybasetreasury"
                  element={<TreasuryBase />}
                />
                <Route
                  path="/home/bnbcondotreasury"
                  element={<BNBCondoTreasury />}
                />
                <Route
                  path="/home/mapleCondoTreasury"
                  element={<MapleCondoTreasury />}
                />
                <Route path="/home/eth2x" element={<IndexCoopTreasury />} />
                <Route path="/home/devwallet" element={<DevWallet />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </TreasuryContextProvider>
    </div>
  );
}

export default App;
